import { Link } from 'react-router-dom';

import { useLogout } from '../hooks/mutations/useLogout';
import { PATHS } from '../paths';
import { useAuthState } from '../providers/AuthProvider';

import Button from './Button';
import { CommandPaletteTrigger } from './CommandPalette';

/**
 * Minimal top bar: MOPS wordmark (home link) on the left, the command
 * palette's search-box stand-in in the middle, signed-in-as email + logout on
 * the right. Dense, borders over backgrounds, single accent. The wordmark is
 * the universal way back to the tool grid from any scene.
 */
const Header = () => {
  const { user } = useAuthState();
  const { logout, isLoggingOut } = useLogout();

  return (
    <header className="border-border-primary bg-bg-primary text-fg-primary grid grid-cols-[1fr_auto_1fr] items-center gap-6 border-b px-6 py-3">
      <Link
        to={PATHS.HOME}
        aria-label="MOPS home"
        className="focus-visible:outline-border-brand flex items-baseline gap-3 justify-self-start focus-visible:outline-2 focus-visible:outline-offset-4"
      >
        <span className="text-fg-brand-primary hover:text-fg-brand-primary_alt text-lg font-semibold tracking-tight transition-colors">
          MOPS
        </span>
        <span className="text-fg-tertiary text-xs uppercase tracking-widest">admin</span>
      </Link>
      <CommandPaletteTrigger />
      <div className="flex items-center gap-4 justify-self-end text-xs">
        {user && <span className="text-fg-secondary font-mono">{user.email}</span>}
        <Button
          size="xs"
          color="secondary"
          isLoading={isLoggingOut}
          onClick={() => {
            void logout();
          }}
        >
          Log out
        </Button>
      </div>
    </header>
  );
};

export default Header;
